(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmCampaign', CrmCampaign);

    CrmCampaign.$inject = ['$resource'];

    function CrmCampaign ($resource) {
        var resourceUrl =  'api/crm-campaigns/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'filter': {url: 'api/crm-campaigns/filter', method: 'GET', isArray: true}
        });
    }
})();
